module.exports = __webpack_public_path__ + "img/chr_ts_24_penlight.c5c3a6ac.png";